export default __webpack_public_path__ + "static/media/base_phone_2-fs8.b5ca780f.png";